module.exports = __webpack_public_path__ + "static/img/ban01.3a9378d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/ban01.jpg
// module id = xG3B
// module chunks = 1